export default __webpack_public_path__ + "static/background-7d146d878e8f675a82c131982ad92afe.png";